// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"styles_checkboxContainer__2uaHW"};